<template>
  <div class="content">
    <div class="mask" v-show="maskShow"></div>
    <div class="banner">
      <img src="../../img/mobile/Banner.png" />
    </div>
    <el-form class="checkNum" label-width="0" :model="validateForm" ref="validateForm">
      <div class="title-container">
        <p class="title">工号</p>
      </div>
      <el-form-item
        prop="workNum"
        :rules="[{required: true,validator: checkWorkNum, trigger: 'change' }]"
        style="-webkit-user-select:all !important"
      >
        <el-input placeholder="请输入工号" v-model="validateForm.workNum"></el-input>
      </el-form-item>
      <el-form-item
        prop="passWord"
        :rules="[{required: true,validator: checkPassWord, trigger: 'change' }]"
        style="-webkit-user-select:all !important"
      >
        <el-input placeholder="请输入身份证后6位" v-model="validateForm.passWord"></el-input>
      </el-form-item>
    </el-form>
    <el-button
      type="primary"
      :disabled="workFlag === 1 && passFlag === 1 ? false : true"
      @click="nextStep('validateForm')"
      v-loading.fullscreen.lock="fullscreenLoading"
    >下一步</el-button>
    <tipBox v-bind.sync="showBombTips" :tipsContent="tipsContent"></tipBox>
    <downloadTip :maskShow="maskShow"></downloadTip>
  </div>
</template>

<script>
import tipBox from "../../components/mobile/tipBox";
import downloadTip from "../../components/mobile/downloadTip";
export default {
  components: {
    tipBox,
    downloadTip
  },
  data() {
    return {
      maskShow: false,
      workFlag: 0,
      passFlag: 0,
      validateForm: {
        workNum: "",
        passWord: ""
      },
      showBombTips: {
        visible: false
      },
      tipsContent: "",
      fullscreenLoading: false
    };
  },
  methods: {
    checkWorkNum(rule, value, callback) {
      if (!value) {
        this.workFlag = 0;
      } else {
        this.workFlag = 1;
        // localStorage.setItem("workNum", value);
        this.$cookieStore.setCookie('workNum', value)
      }
    },
    checkPassWord(rule, value, callback) {
      console.log(value, "value");
      if (!value) {
        this.passFlag = 0;
      } else {
        this.passFlag = 1;
      }
    },
    nextStep() {
      console.log("next");
      var that = this;
      that.fullscreenLoading = true;
      setTimeout(() => {
        that.fullscreenLoading = false;
      }, 500);
      var params = {
        employeeCode: that.validateForm.workNum,
        identityCardNum: that.validateForm.passWord
      };
      that.$api
        .checkUserInfo(params)
        .then(res => {
          if (res.data.code === 0) {
            var phone = res.data.data.phone;
            // localStorage.setItem("oldPhone", phone);
            that.$cookieStore.setCookie('oldPhone', phone)
            var editAllow = res.data.data.editAllow;
            // localStorage.setItem("editAllow", editAllow);
            that.$cookieStore.setCookie('editAllow', editAllow)
            var name = res.data.data.employeeName;
            that.$router.push(`/phoneNum?flag=1&&name=${name}`);
          } else if (res.data.code === 60002) {
            that.showBombTips = {
              visible: true
            };
            that.tipsContent = res.data.message;
          } else if (res.data.code === 60003) {
            that.showBombTips = {
              visible: true
            };
            that.tipsContent = res.data.message;
          } else if (res.data.code === 60005){
            that.showBombTips = {
              visible: true
            };
            that.tipsContent = res.data.message;
          }
        })
        .catch(res => {
          console.log(res);
          that.showBombTips = {
            visible: true
          };
          that.tipsContent = res;
        });
    }
  },
  created() {
    // console.log(this.$cookieStore.getCookie,'$cookieStore');
    function is_weixin() {
      var ua = navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    }
    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (is_weixin()) {
      console.log(is_weixin, "is_weixin");
      if (isAndroid) {
        this.maskShow = true;
      } else if (isiOS) {
        this.maskShow = true;
      }
    } else {
      if (isAndroid) {
        this.maskShow = false;
      } else if (isiOS) {
        this.maskShow = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  .weixin-tip {
    left: 0;
    top: 0;
    bottom: 0;
    width: 3.48rem;
    position: absolute;
    z-index: 300;
  }
  .mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 1);
    opacity: 0.6;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    z-index: 100;
  }
  .banner {
    height: 3.6rem;
    img {
      width: 7.5rem;
      height: 3.6rem;
    }
  }
  .checkNum {
    position: relative;
    width: 88%;
    margin: 0rem 0.45rem;
    overflow: hidden;
    box-sizing: border-box;
    .title-container {
      position: relative;
      .title {
        height: 0.48rem;
        font-size: 0.34rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        line-height: 0.48rem;
        position: relative;
        left: -3rem;
      }
    }
  }
  button {
    width: 6.6rem;
    height: 0.8rem;
    padding: 0rem;
    font-size: 0.32rem;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 0.8rem;
    border: 0rem;
    border-radius: 0.08rem;
    outline: none;
  }
  .blueBtn {
    background: rgba(34, 142, 243, 1);
  }
  .grayBtn {
    background: rgba(34, 142, 243, 1);
    opacity: 0.45;
  }
  .el-form-item {
    margin-bottom: 0.4rem;
  }
  .el-input {
    height: 0.88rem;
  }
  >>> .el-input__inner{
    height: 0.7rem;
    line-height: 0.7rem;
    font-size: 0.25rem;
  }
  .tipsBox {
    position: relative;
    margin-top: -5rem;
    left: 50%;
    transform: translateX(-35%);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/workNum.vue